import BaseRoute from "../../../lib/itn-ui-kit/route/base-route";

import Template from "./template";

export default class AnalyticsRoute extends BaseRoute {
  element = (<Template />);

  async loader() {
    return {};
  }
}
